// extracted by mini-css-extract-plugin
module.exports = {"loader":"login-module--loader--2x4Fm","authBtns":"login-module--auth-btns--2ddsr","loginBtn":"login-module--loginBtn--1aifY","logoutBtn":"login-module--logoutBtn--3vcmw"};